import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { useParams } from 'react-router-dom';
import { WATCHER_TYPE_CACHE_KEY } from 'services/queryKeys';
import { WatcherType } from 'types';

export function WatcherTypeBreadcrumb() {
  const { watcherTypeId = '' } = useParams();

  const { data: watcherType = {} as WatcherType } = useAxiosQuery<WatcherType>(
    WATCHER_TYPE_CACHE_KEY(watcherTypeId),
    `/watcher-types/${watcherTypeId}/`,
    { enabled: !!watcherTypeId }
  );

  return watcherType?.externalIdentifier ?? watcherTypeId;
}
